import { slice, actions } from "./slice";

export { default as useMenuSelector } from "./useSelector";

export { default as menuThunks } from "./thunks";

export { actions as menuActions };

export default slice;
